import { z } from "zod";
import { BIGGER_FIELD, REQUIRED_FIELD } from "../../../utils/constants";

export const IndicatorManagementItemSchema = z
  .object({
    name: z.string().min(1, { message: REQUIRED_FIELD }),
    indicatorTypeOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    subSystemOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    frequencyOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    indicatorMetricOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    outra: z.string().optional(),
    indicatorVariationsOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    indicatorLevelOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    belowAbsoluteLevel: z.number().optional().nullable(),
    aboveAbsoluteLevel: z.number().optional().nullable(),
    alertVariationCheck: z.boolean().optional(),
    superiorAbsoluteValue: z.number().optional().nullable(),
    minPeriodVariation: z.number().optional().nullable(),
    maxPeriodVariation: z.number().optional().nullable(),
    inferiorYearlyLevelVariations: z.number().optional().nullable(),
    superiorYearlyLevelVariations: z.number().optional().nullable(),
    healthyLevelOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional()
      .nullable(),
    healthyIntervalFrom: z.number().optional().nullable(),
    healthyIntervalTo: z.number().optional().nullable(),
    unhealthyLevelOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional()
      .nullable(),
    unhealthyIntervalFrom: z.number().optional().nullable(),
    unhealthyIntervalTo: z.number().optional().nullable(),
    partnerOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional()
      .nullable(),
    integrationOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional()
      .nullable(),
  })

  .superRefine((data, ctx) => {
    if (data?.indicatorMetricOption.id === 4 && !data.outra) {
      ctx.addIssue({
        path: ["outra"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (
      data?.alertVariationCheck &&
      data?.alertVariationCheck === true &&
      (data.superiorAbsoluteValue === null ||
        data.superiorAbsoluteValue === undefined)
    ) {
      ctx.addIssue({
        path: ["superiorAbsoluteValue"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (data?.healthyLevelOption && !data?.healthyIntervalTo) {
      ctx.addIssue({
        path: ["healthyIntervalTo"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (data?.unhealthyLevelOption && !data?.unhealthyIntervalTo) {
      ctx.addIssue({
        path: ["unhealthyIntervalTo"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (
      data?.healthyLevelOption &&
      data?.healthyLevelOption.id === 4 &&
      !data?.healthyIntervalFrom
    ) {
      ctx.addIssue({
        path: ["healthyIntervalFrom"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (
      data?.unhealthyLevelOption &&
      data?.unhealthyLevelOption.id === 4 &&
      !data?.unhealthyIntervalFrom
    ) {
      ctx.addIssue({
        path: ["unhealthyIntervalFrom"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (
      data?.healthyIntervalFrom &&
      data?.healthyIntervalTo &&
      data.healthyIntervalFrom > data.healthyIntervalTo
    ) {
      ctx.addIssue({
        path: ["healthyIntervalTo"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
    if (
      data?.unhealthyIntervalFrom &&
      data?.unhealthyIntervalTo &&
      data.unhealthyIntervalFrom > data.unhealthyIntervalTo
    ) {
      ctx.addIssue({
        path: ["unhealthyIntervalTo"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
    if (
      data?.belowAbsoluteLevel &&
      data?.aboveAbsoluteLevel &&
      data.belowAbsoluteLevel > data.aboveAbsoluteLevel
    ) {
      ctx.addIssue({
        path: ["aboveAbsoluteLevel"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
    if (
      data?.minPeriodVariation &&
      data?.maxPeriodVariation &&
      data.minPeriodVariation > data.maxPeriodVariation
    ) {
      ctx.addIssue({
        path: ["maxPeriodVariation"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
    if (
      data?.inferiorYearlyLevelVariations &&
      data?.superiorYearlyLevelVariations &&
      data.inferiorYearlyLevelVariations > data.superiorYearlyLevelVariations
    ) {
      ctx.addIssue({
        path: ["superiorYearlyLevelVariations"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
  });

export const IndicatorCollectionItemSchema = z.object({
  partnerOption: z.object({
    id: z.number(),
    name: z.string().min(1, { message: REQUIRED_FIELD }),
  }),
  integrationOption: z.object({
    id: z.number(),
    name: z.string().min(1, { message: REQUIRED_FIELD }),
  }),
  // integrationOption: z.object({
  //   id: z.number(),
  //   name: z.string().min(1, { message: REQUIRED_FIELD }),
  // }),
  // apiKey: z.string().optional(),
});
// .superRefine((data, ctx) => {
//   if (data?.integrationOption.id === 2 && !data.apiKey) {
//     ctx.addIssue({
//       path: ["apiKey"],
//       message: REQUIRED_FIELD,
//       code: "custom",
//     });
//   }
// });

// TODO: not detecting IndicatorCollectionItemSchema, this is required for edit
export const IndicatorManagementCombinedSchema = z
  .object({
    name: z.string().min(1, { message: REQUIRED_FIELD }),
    indicatorTypeOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    subSystemOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    frequencyOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    indicatorMetricOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    outra: z.string().optional(),
    indicatorVariationsOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    indicatorLevelOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    belowAbsoluteLevel: z.number().optional().nullable(),
    aboveAbsoluteLevel: z.number().optional().nullable(),
    alertVariationCheck: z.boolean().optional(),
    superiorAbsoluteValue: z.number().optional().nullable(),
    minPeriodVariation: z.number().optional().nullable(),
    maxPeriodVariation: z.number().optional().nullable(),
    inferiorYearlyLevelVariations: z.number().optional().nullable(),
    superiorYearlyLevelVariations: z.number().optional().nullable(),
    healthyLevelOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional()
      .nullable(),
    healthyIntervalFrom: z.number().optional().nullable(),
    healthyIntervalTo: z.number().optional().nullable(),
    unhealthyLevelOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional()
      .nullable(),
    unhealthyIntervalFrom: z.number().optional().nullable(),
    unhealthyIntervalTo: z.number().optional().nullable(),
    partnerOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    integrationOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
  })

  .superRefine((data, ctx) => {
    if (data?.indicatorMetricOption.id === 4 && !data.outra) {
      ctx.addIssue({
        path: ["outra"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (
      data?.alertVariationCheck &&
      data?.alertVariationCheck === true &&
      (data.superiorAbsoluteValue === null ||
        data.superiorAbsoluteValue === undefined)
    ) {
      ctx.addIssue({
        path: ["superiorAbsoluteValue"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (data?.healthyLevelOption && !data?.healthyIntervalTo) {
      ctx.addIssue({
        path: ["healthyIntervalTo"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (data?.unhealthyLevelOption && !data?.unhealthyIntervalTo) {
      ctx.addIssue({
        path: ["unhealthyIntervalTo"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (
      data?.healthyLevelOption &&
      data?.healthyLevelOption.id === 4 &&
      !data?.healthyIntervalFrom
    ) {
      ctx.addIssue({
        path: ["healthyIntervalFrom"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (
      data?.unhealthyLevelOption &&
      data?.unhealthyLevelOption.id === 4 &&
      !data?.unhealthyIntervalFrom
    ) {
      ctx.addIssue({
        path: ["unhealthyIntervalFrom"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
    if (
      data?.healthyIntervalFrom &&
      data?.healthyIntervalTo &&
      data.healthyIntervalFrom > data.healthyIntervalTo
    ) {
      ctx.addIssue({
        path: ["healthyIntervalTo"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
    if (
      data?.unhealthyIntervalFrom &&
      data?.unhealthyIntervalTo &&
      data.unhealthyIntervalFrom > data.unhealthyIntervalTo
    ) {
      ctx.addIssue({
        path: ["unhealthyIntervalTo"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
    if (
      data?.belowAbsoluteLevel &&
      data?.aboveAbsoluteLevel &&
      data.belowAbsoluteLevel > data.aboveAbsoluteLevel
    ) {
      ctx.addIssue({
        path: ["aboveAbsoluteLevel"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
    if (
      data?.minPeriodVariation &&
      data?.maxPeriodVariation &&
      data.minPeriodVariation > data.maxPeriodVariation
    ) {
      ctx.addIssue({
        path: ["maxPeriodVariation"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
    if (
      data?.inferiorYearlyLevelVariations &&
      data?.superiorYearlyLevelVariations &&
      data.inferiorYearlyLevelVariations > data.superiorYearlyLevelVariations
    ) {
      ctx.addIssue({
        path: ["superiorYearlyLevelVariations"],
        message: BIGGER_FIELD,
        code: "custom",
      });
    }
  });
